import { render, staticRenderFns } from "./closureTemplatesForm.vue?vue&type=template&id=4270e0a0"
import script from "./closureTemplatesForm.vue?vue&type=script&lang=js"
export * from "./closureTemplatesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4270e0a0')) {
      api.createRecord('4270e0a0', component.options)
    } else {
      api.reload('4270e0a0', component.options)
    }
    module.hot.accept("./closureTemplatesForm.vue?vue&type=template&id=4270e0a0", function () {
      api.rerender('4270e0a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EnduserDeclarationAdmin/closureTemplatesForm.vue"
export default component.exports